import { useDispatch, useSelector } from "react-redux";
import {
    setFloatingContainerState,
    setFloatingWindowState,
    setHeaderState,
    setQuitConfirmationState,
    setSendMessageContainerState,
} from "../../../features/componentStateSlice.js";
import {
    setIsEnd,
    setIsCountTimerClose,
    resetTimer,
    setIsFromQuitButton,

} from "../../../features/messagesSlice.js";
import { setSurveyFormState } from "../../../features/surveySlice.js";

export default function QuitButton() {
    const dispatch = useDispatch();
    const autoCloseTimerId = useSelector(
        (state) => state.messages.autoCloseTimerId
    );
    const isCountTimerClose = useSelector(
        (state) => state.messages.isCountTimerClose
    );

    const isEnd = useSelector((state) => state.messages.isEnd)

    const handleQuitButtonClick = () => {
        dispatch(setIsFromQuitButton(true))
      if (!isCountTimerClose && isEnd) {
        dispatch(setFloatingContainerState(true));
        dispatch(setFloatingWindowState(false));
        dispatch(setHeaderState(false));
        dispatch(setSendMessageContainerState(false));
      }
       
      dispatch(setIsEnd(true));
      dispatch(setQuitConfirmationState(false));
      
    };

    return (
        <button id="quit-button" onClick={handleQuitButtonClick}>
            Quit
        </button>
    );
}
